import React from 'react';

import '../modules/Module.css';
import ReportInfoModule from '../modules/ReportInfoModule';
import MedicReportFeedbackModule from '../modules/MedicReportFeedbackModule';

const MedicReportFeedbackBox = ({ user, reportId, isSmallScreen, readAsMedic = false }) => {
    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            {/* <h1 className='box-title'> Report Feedback to Medic </h1> */}
            <h4></h4>
            <ReportInfoModule reportId={reportId} isSmallScreen={isSmallScreen} showStatus={false} readAsMedic={readAsMedic}/>
            <MedicReportFeedbackModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>
        </div>
    );
};

export default MedicReportFeedbackBox; 